import React from 'react';

export default class TermsAndPrivacy extends React.Component {

  render() {
    return (
      <p>
        By clicking {this.props.btnContent ? this.props.btnContent : 'Sign In'}, you agree to our&nbsp; have read and acknowledge our&nbsp;
          <i>
            <a href="https://www.swiftdebtrelief.com/privacy-policy/" target="_blank" rel="noreferrer noopener">
            Privacy Statement
            </a>
          </i>
      </p>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/TermsAndPrivacy/index.js